import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../components/AnimatedCol";
import HiddenWrapperRow from "../../../../../components/UI/HiddenWrapperRow";
import QuerschnittStahltragglied from "../QuerschnittStahltragglied";
import AnzahlLastwechsel from "./AnzahlLastwechsel";
import Ausnutzung from "./Ausnutzung";
import BemessungswertDerSchwinggrenze from "./BemessungswertDerSchwinggrenze";
import CharakteristischeSchwingbreite from "./CharakteristischeSchwingbreite";
import CharakteristischeSpannungsschwingbreite from "./CharakteristischeSpannungsschwingbreite";
import CharakteristischeSpannungsschwingbreiteDetails from "./CharakteristischeSpannungsschwingbreiteDetails";
import SchwingungsObergrenze from "./SchwingungsObergrenze";
import SchwingungsUntergrenze from "./SchwingungsUntergrenze";
import TeilsicherheitsbeiwertFuerErmuedung from "./TeilsicherheitsbeiwertFuerErmuedung";
import TeilsicherheitsbeiwertFuerErmuedungDetails from "./TeilsicherheitsbeiwertFuerErmuedungDetails";
import TeilsicherheitsbeiwertFuerErmuedungslasten from "./TeilsicherheitsbeiwertFuerErmuedungslasten";
import ZulaessigeBemessungsschwingbreite from "./ZulaessigeBemessungsschwingbreite";

function CharakteristischeEinwirkungen({
  expand,
  ausnutzung,
  upperLower,
  charakteristischeSchwingbreite,
  zulaessigeBemessungsschwingbreite,
  ermudung,
  querschnitt,
}) {
  const { t } = useTranslation("translation");
  const hide = `${expand ? "box" : "d-sm-none"} `;
  const [
    showCharakteristischeSpannungsschwingbreiteDetails,
    setShowCharakteristischeSpannungsschwingbreiteDetails,
  ] = useState(false);
  const [
    showTeilsicherheitsbeiwertFuerErmuedungDetails,
    setShowTeilsicherheitsbeiwertFuerErmuedungDetails,
  ] = useState(false);

  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("inner.fatigue.characteristicEffects")}</h1>
        </div>
      </div>
      <div className="row">
        {/* Schwingungs-Obergrenze */}
        <AnimatedCol>
          <SchwingungsObergrenze />
        </AnimatedCol>

        {/* Schwingungs-Untergrenze */}
        <AnimatedCol>
          <SchwingungsUntergrenze />
        </AnimatedCol>

        {/* Teilsicherheitsbeiwert für Ermüdungslasten */}
        <AnimatedCol expand={expand}>
          <TeilsicherheitsbeiwertFuerErmuedungslasten />
        </AnimatedCol>

        {/* Bemessungswert der Schwingbreite */}
        <AnimatedCol expand={expand}>
          <BemessungswertDerSchwinggrenze upperLower={upperLower} />
        </AnimatedCol>

        {/* Anzahl Lastwechsel */}
        <AnimatedCol>
          <AnzahlLastwechsel
            show={showCharakteristischeSpannungsschwingbreiteDetails}
            showModal={setShowCharakteristischeSpannungsschwingbreiteDetails}
          />
        </AnimatedCol>
        {/* HACK: 0px to keep the row small when the 'DraggableTableBohrkronen' is visible */}
        <HiddenWrapperRow>
          <CharakteristischeSpannungsschwingbreiteDetails
            show={showCharakteristischeSpannungsschwingbreiteDetails}
            setShow={setShowCharakteristischeSpannungsschwingbreiteDetails}
          />
        </HiddenWrapperRow>

        <div className="col-md-8">
          <p>
            <Trans
              i18nKey="inner.fatigue.infoText"
              values={{
                tensionSwingingGamesValue: "10<sup>6</sup>",
                fatigueStrengthCurve: "Δσ<sub>c</sub>",
              }}
              components={{ sup: <sup />, sub: <sub /> }}
            />
          </p>
          <hr />
        </div>

        {/* charakteristische Spannungsschwingbreite */}
        <AnimatedCol expand={expand}>
          <CharakteristischeSpannungsschwingbreite value={ermudung} />
        </AnimatedCol>

        <AnimatedCol expand={expand}>
          <QuerschnittStahltragglied querschnitt={querschnitt} />
        </AnimatedCol>
        {/* charakteristische Schwingbreite */}
        <AnimatedCol expand={expand}>
          <CharakteristischeSchwingbreite
            charakteristischeSchwingbreite={charakteristischeSchwingbreite}
          />
        </AnimatedCol>

        {/* Teilsicherheitsbeiwert für Ermüdung */}
        <AnimatedCol>
          <TeilsicherheitsbeiwertFuerErmuedung
            showModal={setShowTeilsicherheitsbeiwertFuerErmuedungDetails}
            show={showTeilsicherheitsbeiwertFuerErmuedungDetails}
          />
        </AnimatedCol>
        {/* HACK: 0px to keep the row small when the 'DraggableTableBohrkronen' is visible */}
        <HiddenWrapperRow>
          <TeilsicherheitsbeiwertFuerErmuedungDetails
            show={showTeilsicherheitsbeiwertFuerErmuedungDetails}
            setShow={setShowTeilsicherheitsbeiwertFuerErmuedungDetails}
          />
        </HiddenWrapperRow>

        {/* Bemessungswert der Schwingbreite */}
        <AnimatedCol>
          <ZulaessigeBemessungsschwingbreite
            zulaessigeBemessungsschwingbreite={zulaessigeBemessungsschwingbreite}
          />
        </AnimatedCol>

        {/* Ausnutzung */}
        <AnimatedCol>
          <Ausnutzung ausnutzung={ausnutzung} />
        </AnimatedCol>
      </div>
    </div>
  );
}

export default CharakteristischeEinwirkungen;
